import api from '../../../utils/api';

export async function submitClubJoinRequest(clubId, { message, title } = {}) {
  const payload = { message: message?.trim() || '' };
  if (title?.trim()) payload.title = title.trim();
  const res = await api.post(`/clubs/discover/${clubId}/join-request/`, payload);
  return res.data;
}

export async function fetchClubJoinRequests(clubId, { status = 'pending' } = {}) {
  const params = {};
  if (status) params.status = status;
  const res = await api.get(`/clubs/${clubId}/join-requests/`, { params });
  return res.data;
}

export async function approveClubJoinRequest(clubId, requestId) {
  const res = await api.post(`/clubs/${clubId}/join-requests/${requestId}/approve/`);
  return res.data;
}

export async function declineClubJoinRequest(clubId, requestId) {
  const res = await api.post(`/clubs/${clubId}/join-requests/${requestId}/decline/`);
  return res.data;
}

export function defaultJoinRequestTitle(clubName) {
  return clubName ? `Membership request — ${clubName}` : 'Membership request';
}

export function joinRequestErrorMessage(err, fallback = 'Could not submit your request.') {
  const apiError = err?.response?.data?.error;
  if (typeof apiError === 'string' && apiError.trim()) return apiError;
  if (typeof err?.message === 'string' && err.message.trim()) return err.message;
  return fallback;
}
